import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=wide%20dreamy%20illustration%20of%20a%20group%20of%20cute%20fluffy%20cats%20and%20animals%20relaxing%20on%20a%20cozy%20sunlit%20field%20with%20flowers%2C%20floating%20sparkles%20and%20soft%20clouds%2C%20warm%20peach%20and%20cream%20palette%2C%20soft%20rounded%20kawaii%20storybook%20vector%20art%2C%20gentle%20healing%20atmosphere%2C%20bright%20and%20cheerful&width=1600&height=900&seq=hero-home-v1&orientation=landscape"
          alt="喵趣漫画网萌系日常主题插画，暖色治愈背景"
          title="喵趣漫画网 - 萌系日常与治愈番合集"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/85 via-background-50/40 to-background-50"></div>
      </div>

      <div className="container-page relative z-10 flex w-full flex-col items-center py-20 text-center md:py-28">
        <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-background-50/80 px-4 py-1.5 text-xs font-bold text-primary-700 backdrop-blur">
          <i className="ri-sparkling-line text-sm" aria-hidden="true"></i>
          萌系日常 · 治愈番 · 软萌画风 精选合集
        </span>

        <h1 className="mt-6 max-w-3xl text-3xl font-bold leading-tight text-foreground-950 md:text-5xl">
          不用费脑，点开就开心
          <span className="mt-2 block text-primary-600">今天也要元气满满呀</span>
        </h1>

        <p className="mt-5 max-w-2xl text-sm leading-7 text-foreground-700 md:text-base">
          喵趣漫画网为你精挑细选治愈番、搞笑萌漫、软萌画风与温馨向轻喜剧，
          一部部轻松好看的作品，专治碎片时间不知道看什么的烦恼，追更不踩雷。
        </p>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <Link to="/category/all" className="btn-primary px-7 py-3 text-base">
            开始追更 <i className="ri-arrow-right-line ml-1" aria-hidden="true"></i>
          </Link>
          <Link to="/about" className="btn-ghost px-7 py-3 text-base">
            了解我们
          </Link>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-6 text-sm text-foreground-700">
          <span className="flex items-center gap-2">
            <i className="ri-heart-3-fill text-accent-500" aria-hidden="true"></i>
            12部高分治愈番
          </span>
          <span className="flex items-center gap-2">
            <i className="ri-emotion-laugh-line text-primary-600" aria-hidden="true"></i>
            86万次追更收藏
          </span>
          <span className="flex items-center gap-2">
            <i className="ri-refresh-line text-secondary-700" aria-hidden="true"></i>
            每周更新编辑精选
          </span>
        </div>
      </div>
    </section>
  );
}